import history from '../../../lib/history';
import historyReplace from '../../../actions/history/replace-history';

const getReturnPath = path => () =>
  historyReplace(`${path}${history.location.search}`);

export default getReturnPath;
